import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined';
import styles from './FloraLibraryUploadCard.module.css';

interface FloraLibraryUploadCardProps {
	onClick?: () => void;
}

export const FloraLibraryUploadCard = ({ onClick }: FloraLibraryUploadCardProps) => {
	return (
		<button type="button" className={styles.card} onClick={onClick}>
			<FileUploadOutlined className={styles.icon} />
			<span className={styles.title}>Enviar documento</span>
			<span className={styles.subtitle}>
				Arraste os arquivos aqui
				<br />
				PDF, XLS, CSV ou PNG até 25 MB
			</span>
		</button>
	);
};
